const getBuildTime = () => {
  return (new Date()).toISOString();
};

const escape = (str) => {
  if(str) {
    str = str.replace(/"/g, '\\"');
    const parts = str.split('\\');
    str = parts.join('\\\\');
  }
  return str;
};


const toWebPageJsonLd = (args) => {
  const {title, description, canonical, siteUrl, language, publishedAt} = args;
  return `
    {
        "@context": "http://schema.org",
        "@type": "WebPage",
        "url": "${canonical}",
        "mainEntityOfPage": "${siteUrl}",
        "name": "${title}",
        "inLanguage": "${language}",
        "description": "${escape(description)}",
        "copyrightYear": "2022",
        "datePublished": "${publishedAt}",
        "dateModified": "${getBuildTime()}",
        "publisher": {
            "@type": "Organization",
            "name": "Sciences Po"
        }
    }`;
};


const toNewsJsonLd = (args) => {
  const {imageUri, publishedAt: publicationDate, title, description,
    canonical,
    author, language} = args;

  let image = '';
  if (imageUri) {
    image = `
           "image": [
              "${imageUri}"
           ],
        `;
  }

  let articleAuthor = '';
  if (author) {
    articleAuthor = `
          "author": {
            "@type": "Person",
            "name": "${author}"
          },
        `;
  }

  return `
    {
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "${canonical}"
        },
        "inLanguage": "${language}",
        "name": "${escape(title)}",
        "headline": "${escape(title)}",
        ${image}
        "datePublished": "${publicationDate}",
        "dateModified": "${publicationDate}",
        ${articleAuthor}
         "publisher": {
          "@type": "Organization",
          "name": "Sciences Po"
        },
        "description": "${escape(description)}"
      }
    `;
};


const addressMap = {
  'street': 'streetAddress',
  'city': 'addressLocality',
  'zip': 'postalCode',
  'country': 'addressCountry'
};


const getEvtAddress = (street, city, zip, country) => {
  if (street || city || zip || country) {
    const addressArr = [];
    if( street) {
      addressArr.push(`"${addressMap['street']}":"${street}"`);
    }
    if( city) {
      addressArr.push(`"${addressMap['city']}":"${city}"`);
    }
    if( zip) {
      addressArr.push(`"${addressMap['zip']}":"${zip}"`);
    }
    if( country) {
      addressArr.push(`"${addressMap['country']}":"${country}"`);
    }
    return `
           "address": {
                "@type": "PostalAddress",
                ${addressArr.join(',\n')}
           }
        `;
  }
  return '';
};

const toEventJsonLd = (args) => {
  const {
    title: name, uri, description,
    start_date: startDate,
    end_date: endDate, eventLocation,
    coverImageUrl,
    eventLive
  } = args;
  const {room, event_address} = (eventLocation || {});
  const {city, zip, country, address: street} = (event_address || {});


  let location = '';
  const address = getEvtAddress(street, city, zip, country);

  const lcArray = [];
  if (room) {
    lcArray.push(`"name":"${room}"`);
  }
  if (address && address !== '') {
    lcArray.push(address);
  }
  if (lcArray.length > 0) {
    location = `
          "location": {
            "@type": "Place",
            ${lcArray.join(',\n')}
          }
         `;
  }


  const arr = [
    '"@context": "https://www.schema.org"',
    '"@type": "Event"',
    `"name": "${escape(name)}"`,
    '"eventStatus": "https://schema.org/EventScheduled"',
    `"organizer": {
                    "@type": "Organization",
                    "name": "Sciences Po",
                    "url": "https://www.sciencespo.fr"
                }`
  ];
  if (eventLive) {
    arr.push('"eventAttendanceMode":"OnlineEventAttendanceMode"');
  } else {
    arr.push('"eventAttendanceMode":"https://schema.org/OfflineEventAttendanceMode"');
  }

  if (uri) (
    arr.push(`"url": "${uri}"`)
  );
  if (coverImageUrl) {
    arr.push(`"image": [
            "${coverImageUrl}"
        ]`);
  }
  if (startDate) {
    arr.push(`"startDate": "${startDate}"`);
  }
  if (endDate) {
    arr.push(`"endDate": "${endDate}"`);
  }


  if (description && description !=='') {
    arr.push(`"description": "${description}"`);
  }

  if (location && location !== '') {
    arr.push(location);
  }

  return `
        {
            ${arr.join(',\n')}
        }
    `;
};

const toPerson = (args) => {
  const arr = [
    '"@context": "https://schema.org"',
    '"@type": "Person"',
    `"name": "${args.title}"`,
  ];
  return `
        {
            ${arr.join(',\n')}
        }
    `;
};


const toExEDProduct = (args) => {
  const arr = [
    '"@context": "https://www.schema.org"',
    '"@type": "Course"',
    `"name": "${args.title}"`,
    `"description":"${args.description}"`,
    `"provider": {
                    "@type": "Organization",
                    "name": "Sciences Po - Executive Education",
                    "sameAs": "https://www.sciencespo.fr/exed"
                }
            }`
  ];
  return `
        {
            ${arr.join(',\n')}
        }
    `;
};


const toLdJson = (args) => {
  const {type} = args;
  if (type === 'Event') {
    return toEventJsonLd (args);
  } else if (type === 'News') {
    return toNewsJsonLd (args);
  } else if (type === 'InternalPage') {
    return toWebPageJsonLd (args);
  } else if (type === 'ExEDProduct'){
    return toExEDProduct(args);
  } else if (type === 'People') {
    return toPerson(args);
  }
  return null;
};

module.exports = {
  toLdJson,
  toEventJsonLd,
  toWebPageJsonLd,
  toNewsJsonLd
};